import branchapi from "./branch";

export const fetchBranchesNoPaginateApi = async () => {
  const response = await branchapi.get("Branches/no-paginate");
  return response.data;
};
